import builtinForms from './builtinForms.json';
export interface GroupableForm { id: string; name: string; group?: string }
// Flat presentation groups; custom forms remain selectable without changing their IDs.
export function formGroup(form: GroupableForm): string {
  if (form.group?.trim()) return form.group.trim();
  const known = builtinForms.find(item => item.id.toLowerCase() === form.id.toLowerCase());
  if (known) return known.group;
  const id = form.id.toUpperCase();
  if (/^(SAL|PUR|STK)_/.test(id)) return '供应链';
  if (/^(AR|AP|CN|GL|ER)_/.test(id)) return '财务会计';
  if (/^(PRD|SUB|ENG|MRP)_/.test(id)) return '生产制造';
  if (/^QM_/.test(id)) return '质量管理';
  if (/^(BD|ORG|BOS)_/.test(id)) return '基础管理';
  if (/^FA_/.test(id)) return '资产管理';
  return '其他表单';
}
export function groupedForms<T extends GroupableForm>(forms: T[], search: string): {name: string; items: T[]}[] {
  const query = search.trim().toLocaleLowerCase();
  const groups = new Map<string, T[]>();
  forms.forEach(form => {
    const group = formGroup(form);
    if (query && !`${form.name} ${form.id} ${group}`.toLocaleLowerCase().includes(query)) return;
    if (!groups.has(group)) groups.set(group, []);
    groups.get(group)!.push(form);
  });
  return Array.from(groups, ([name, items]) => ({name, items}));
}

export function mergeBuiltinForms(forms: GroupableForm[]): GroupableForm[] {
  const result = [...forms];
  const ids = new Set(forms.map(form => form.id.toLowerCase()));
  builtinForms.forEach(form => { if (!ids.has(form.id.toLowerCase())) { result.push(form); ids.add(form.id.toLowerCase()); } });
  return result;
}
